var map = {
	"./angular.png": 8753,
	"./contentful.png": 7586,
	"./css.png": 6586,
	"./digital-ocean.png": 3365,
	"./django.png": 6133,
	"./docker.png": 188,
	"./firebase.png": 2372,
	"./gcp.png": 3123,
	"./github.png": 4577,
	"./html.png": 5685,
	"./js.png": 8497,
	"./landingportrait.png": 6263,
	"./next.png": 329,
	"./nodejs.png": 7539,
	"./psql.png": 2376,
	"./python.png": 5611,
	"./react.png": 1750,
	"./redux.png": 3262,
	"./sfulogo.png": 9865,
	"./socketio.png": 9806,
	"./tailwind.png": 429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9464;